import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MovementOrdersComponent } from './component/movement-orders.component';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MovementOrderDetailsComponent } from './component/movement-order-details/movement-order-details.component';

import { TmcYardCommonModule } from 'src/tmc-yard/common/common.module';
import { MovementOrderStrategyDialogComponent } from './component/movement-order-strategy-dialog/movement-order-strategy-dialog.component';
import { StructureSelectionModule } from 'src/tmc-yard/common/structure-selection/structure-selection.module';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { MovingOrderVehicleSelectionComponent } from './component/moving-order-vehicle-selection/moving-order-vehicle-selection.component';
import { MovementOrderReroutingDialogComponent } from './component/movement-order-rerouting-dialog/movement-order-rerouting-dialog.component';



@NgModule({
  declarations: [
    MovementOrdersComponent,
    MovementOrderDetailsComponent,
    MovementOrderStrategyDialogComponent,
    MovingOrderVehicleSelectionComponent,
    MovementOrderReroutingDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    CommonUIModule,
    CommonLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    CommonTranslationModule,
    TmcYardCommonModule,
    StructureSelectionModule,
    ServiceResponseModule
  ],
  exports: [
    MovementOrdersComponent
  ]
})
export class MovementOrdersModule { }
